import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Box, Container } from "@mui/material";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./components/Home";
import About from "./components/About";
import Conditioning from "./components/Conditioning";
import Questionnaire from "./components/Questionnaire";
import HowToUse from "./components/HowToUse";

const App = () => {
  return (
    <Router>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh", // Ensures the container takes full viewport height
        }}
      >
        <Navbar />

        {/* Main Content Area (Expands to fill remaining space) */}
        <Box component="main" sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
          <Container sx={{ flexGrow: 1, py: 3 }}> {/* Added Container for better layout */}
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/questionnaire" element={<Questionnaire />} />
              <Route path="/conditioning" element={<Conditioning />} />
              <Route path="/how-to-use" element={<HowToUse />} />
            </Routes>
          </Container>
        </Box>

        {/* Footer (Fixed at Bottom) */}
        <Footer />
      </Box>
    </Router>
  );
};

export default App;
